import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Play, X } from "lucide-react";
import api from "@/lib/api";
import { WatchDemoModal } from "@/components/WatchDemoModal";
import { isDemoCompleted } from "@/lib/demoProgress";
import { exploreSampleAndGo } from "@/lib/sampleData";

// Dismissible "watch the demo" nudge for trial users. Additive — rendered inside Layout.
export function DemoHelpBanner() {
  const navigate = useNavigate();
  const [sub, setSub] = useState(null);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isDemoCompleted()) { setDismissed(true); return; }
    api.get("/me/subscription").then((r) => {
      setSub(r.data);
      const key = `demo_help_dismissed_${r.data?.tenant_id}`;
      if (localStorage.getItem(key) === "1") setDismissed(true);
    }).catch((e) => { console.warn("subscription load failed", e); });
    const onDone = () => setDismissed(true);
    window.addEventListener("recoveros:demo-completed", onDone);
    return () => window.removeEventListener("recoveros:demo-completed", onDone);
  }, []);

  if (!sub || !sub.is_trial || sub.expired || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(`demo_help_dismissed_${sub.tenant_id}`, "1");
    setDismissed(true);
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-4 md:px-6 py-2.5 text-sm border-b border-[#16A34A]/20 bg-[#16A34A]/[0.06] text-[#0f7a37]" data-testid="demo-help-banner">
      <div className="flex items-center gap-2 min-w-0">
        <Play size={15} fill="currentColor" className="shrink-0" />
        <span className="font-medium truncate">Need help getting started? Watch our 4-minute demo.</span>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <button
          onClick={() => setOpen(true)}
          className="inline-flex items-center gap-1.5 rounded-none px-3 py-1.5 font-semibold text-white bg-[#16A34A] hover:bg-[#138a3e] transition-colors"
          data-testid="demo-help-watch-btn"
        >Watch Demo</button>
        <button onClick={dismiss} className="opacity-60 hover:opacity-100" aria-label="Dismiss" data-testid="demo-help-dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
      <WatchDemoModal
        open={open} onOpenChange={setOpen} source="trial-banner"
        onSample={() => exploreSampleAndGo(toast)}
        onImport={() => navigate("/import")}
        onBookDemo={() => navigate("/demo")}
      />
    </div>
  );
}
